import React, { Component } from 'react'
import OneLineEditor from '../../../components/OneLineEditor'
import SelectBox from '../../../components/SelectBox'
import EstimationStore from '../../../libs/EstimationStore'
import EstimationActions from '../../../libs/EstimationActions'
import Utils from '../../../libs/Utils'
import ConditionList from '../../../libs/ConditionList'

// 最大階層数
const MAX_CONDITIONS = 10
// 自由入力の選択肢のID
const FREE_INPUT_VALUE = 9

class EstimationConditionsTab extends Component {
  constructor (props) {
    super(props)
    const newData = EstimationActions.getCurrentEstimation() || {};

    this.state = {
      data: newData,
      isEditable: this.props.isEditable,
      isPrintable: this.props.isPrintable,
      listener: null,
    }
  }

  componentDidMount () {
    this.setState({
      listener: EstimationStore.addListener('change', () => {
        const newData = EstimationActions.getCurrentEstimation() || {};
        this.setState({
          data: newData
        })
      })
    })
  }

  componentWillUnmount () {
    if (this.state.listener) this.state.listener.remove()
  }

  render() {
    const estimationData = this.state.data || {};
    const conditions = [];
    const inputStyle = {
      backgroundColor: this.state.isEditable ? '#ffffff' : '#FFFFFF',
      cursor: this.state.isEditable ? 'pointer' : 'normal',
      minHeight: '1.4em',
      marginBottom: '6px',
      padding: '5px',
      flex: '1 1 80%'
    }

    for (let i = 0; i < MAX_CONDITIONS; i++) {
        const key = `estimationConditions${i}`;
        
        // 値が存在すれば追加
        if (estimationData[key] !== undefined) {
            conditions.push({ value: estimationData[key], index: i });
        } else {
            // 値が存在しない場合はループを終了
            break;
        }
    }

    // どの条件も存在しない場合、最初の要素を追加 (EstimationActionsでの自動追加がない場合に備えて)
    if (conditions.length === 0) {
        // 表示用のダミー要素
        conditions.push({ value: 0, index: 0 }); 
    }
    
    // conditions配列の最後の要素が 0 でなく、かつ 10個未満であれば、
    // 次の空欄(value: 0)を追加して、ユーザーが選択できるようにする
    const lastCondition = conditions[conditions.length - 1];
    if (lastCondition && lastCondition.value !== 0 && conditions.length < MAX_CONDITIONS) {
        conditions.push({ value: 0, index: conditions.length });
    }
    const canAdd = conditions.length < MAX_CONDITIONS

    return (
      <div>
        <article className='kw-katawaku-art'>
          <div className="kw-container">
            <div className='alert alert-block alert-info'>
              <h5>【見積条件入力設定】</h5>

              {conditions.map((condition, index) => (
                <div key={`condition-${condition.index}-${condition.value}`} style={{ 
                 marginBottom: '8px',
                 display: 'flex', 
                 alignItems: 'center'
               }}>
                 <div style={{ flex: '0 1 20%', marginRight: '10px' }}> 
                 <SelectBox
                    bindingDataAttribute={`estimationConditions${condition.index}`}
                    callback={(data, key, changedValue) => {
                      EstimationActions.updateEstimationConditionValue(condition.index, data, key, changedValue)
                      this.setState({})
                    }}
                    options={ConditionList}
                 />
                 </div>
                 
                 {Number(condition.value) === FREE_INPUT_VALUE && (
                   <div style={inputStyle}>
                     <OneLineEditor bindingDataAttribute={`estimationConditionsFree${condition.index}`} />
                   </div>
                 )}
               </div>
              ))}
            </div>
          </div>
        </article>
      </div>
    )
  }
}

EstimationConditionsTab.defaultProps = {isEditable: true}
export default EstimationConditionsTab


// WEBPACK FOOTER //
// ./src/company_user/pages/secure/EstimationEdit/EstimationConditionsTab.js